import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';

@Injectable()
export class UndefinedRequestInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request && request.url.includes('undefined')) {
      console.log('UndefinedRequestInterceptor request.url contains undefined', request);

      return of(new HttpResponse({
        status: 400, statusText: 'Bad Request', body: { error: 'Invalid request' }
      }));
    }

    return next.handle(request);
  }
}
